<template>

    <div class="col-holder">
      <div class="col-head" @click="onAddJob(listId)" >
        <span>{{name}}</span>
        <v-icon class="add-button" :data-v-step="listId">add</v-icon>
      </div>
      <div class="col-body">
        <!-- fallbackTolerance is due to an odd issue where some mouse mats can cause oversensitive mice to not recognise a click or a drag -->
        <draggable
        v-model='myList'
        group="jobs"
        animation="100"
        handle=".details"
        style="flex-grow:1;"
        class="drag-list"
        @end='onEnd(listId, $event)'
        :data-listid='listId'
        delay-on-touch-only="true"
        delay="100"
        touchStartThreshold=50
        forceFallback="true"
        dragClass="sortable-drag"
        chosenClass="sortable-chosen"

        >
          <!-- <transition-group name="list-complete" style="display:block; min-height:50vh;"> -->
            <job v-for="(job, index) in myList"  :key="job.id" :id="job.id" :listId="listId" :job="job" :index="index"></job>
          <!-- </transition-group> -->
        </draggable>
      </div>
      <transition name="slide">
        <div v-if="showTotals" class="col-total">
          <display-amount :totalAmount="columnTotal" :totalNetAmount="columnTotalNet"></display-amount>
        </div>
      </transition>
    </div>
</template>

<script>
import { handleJobMovingColumn } from '@/components/Mixins/handleJobMovingColumn'
import draggable from 'vuedraggable'
import Job from '@/components/Board/Job'
import DisplayAmount from '@/components/Shared/DisplayAmount'

export default {
  name: 'Column',
  components: {
    Job,
    draggable,
    DisplayAmount
  },
  mixins: [handleJobMovingColumn],
  props: {
    listId: Number,
    name: String,
    showTotals: Boolean
  },
  data () {
    return {
      showCard: false,
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol,
      displayWithTax: this.$store.getters.group.displayWithTax || false,
      user: this.$store.getters.user
    }
  },
  computed: {
    myList: {
      get () {
        return this.$store.getters['OrderedJobs' + this.listId]
      },
      set (value) {
        let i = ''
        let listData = {}
        let id = ''
        let thisobj = {}
        for (i = 0; i < value.length; i++) {
          if (value[i].id !== 'undefined' && value[i].id !== null) {
            // text += value[i].id + '<br>'
            id = value[i].id
            let marked = value[i].marked || ''
            thisobj = {
              ...value[i],
              id: id,
              listId: this.listId,
              marked: marked,
              order: i
            }
            listData[id] = thisobj
          }
        }
        const listId = this.listId
        this.$store.dispatch('updateList', { listId: listId, listData: listData })
      }
    },
    lowestOrder: function () {
      if (this.myList.length > 0) {
        return this.myList[0].order - 1
      } else {
        return 0
      }
    },
    columnTotal: function () {
      let total = []
      Object.entries(this.myList).forEach(([key, val]) => {
        total.push(val.amount) // the value of the current key.
      })
      return total.reduce(function (total, num) { return parseFloat(total) + parseFloat(num) }, 0)
    },
    columnTotalNet: function () {
      let total = []
      Object.entries(this.myList).forEach(([key, val]) => {
        total.push(val.totalNetAmount) // the value of the current key.
      })
      return total.reduce(function (total, num) { return parseFloat(total) + parseFloat(num) }, 0)
    }
  },
  methods: {
    async onEnd (listid, evt) {
      // https://github.com/SortableJS/Vue.Draggable#events
      // handle the job moving between columns with confirmation modals and
      // keeping the invoive status and dates in sync
      const itemId = evt.item.id
      const hasInvoice = evt.item.dataset.hasInvoice || false
      const fromList = evt.from.dataset.listid
      const toList = evt.to.dataset.listid
      const invoiceRef = evt.item.dataset.invoiceRef
      return this.handleJobMovingColumn(
        itemId,
        Boolean(hasInvoice),
        Number(fromList),
        Number(toList),
        invoiceRef
      )
    },
    onAddJob (listnumber) {
      // Vuex
      // console.log('add to list' + (listnumber))
      this.$store.dispatch('addJob', { list: listnumber, order: this.lowestOrder })
    },
    removeJob (jobId) {
      const listId = this.listId
      this.$store.dispatch('removeJob', { listId, jobId })
    },
    updateJob (job) {
      const listId = this.listId
      this.$store.dispatch('updateJob', { listId: listId, payload: job })
    }
  }
}
</script>

<style lang="scss">

  .col-holder{
  // width:300px;
  width:20%;
  min-width:220px;
  display:flex;
  flex-direction: column;
  position:relative;

  .xsOnly &{
      width:100%;
  }
}
  .col-head {
    margin: 20px 12px 20px;
    padding:0px 10px 0 15px;
    cursor:pointer;

    background-color:#fff;
    box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.1);
    transition: all 100ms;

    &:hover{
      transform:translateY(-1px);
    box-shadow: 0px 0px 15px 1px rgba(0,0,0,0.1);

    }
    span{
      font-weight:700;
      font-size: 1.3rem;
      line-height:36px;
    }
    .add-button{
      float:right;
      color:var(--dark-text);
      line-height:36px;
      font-size:1.3rem;
    }
  }
  .col-body{
    // margin: 20px 12px 0;
    padding: 0px 12px 0;
    flex: 1;
    display:flex;
    flex-direction:column;
    overflow-y:scroll;

    // max-height:calc(100svh - 190px);
    max-height:calc(100dvh - 190px);
    max-height: -webkit-fill-available;
  }
  .condensed .col-body{
    // max-height:calc(100svh - 180px);
    max-height: -webkit-fill-available;
    max-height:calc(100dvh - 180px);
  }
  // .mdAndDown .col-body{

  // }
  .drag-list{
    flex:1;
  }
  .col-total{
    height:40px;
    color:#fff;
    text-align:center;
    font-size:1.35em;
    font-weight:700;
    height:36px;
    line-height:36px;
    padding:0 15px;
    background:var(--green);
    opacity:1;
    position:absolute;
    bottom:0;
    width:100%;
  }
  .slide-enter-active, .slide-leave-active {
  transition: margin-bottom .1s ease-out;
}

.slide-enter, .slide-leave-to {
  margin-bottom: -50px;
}

.slide-enter-to, .slide-leave {
  margin-bottom: 0px;
}

  .job-card{
    // transition: transform 400ms cubic-bezier(.47,1.64,.41,.8);
  }
  .sortable-ghost{
    /* border:red 1px solid; */
    // border:1px dashed rgba(0, 0, 0, .4);
    // box-shadow:none;
    background:#ccc;
    // height:70px;
    opacity:.4;
    > * {
      opacity:0;
    }
  }
  .sortable-chosen{
    // transform: scale(1.1);
  }
  .sortable-drag{
    // border:purple 8px solid;
  }

  .list-complete-enter-active {
    transition: opacity .6s;

}

.list-complete-leave-active {
    transition:none;

}

.list-complete-enter, .list-complete-leave-to {
    opacity: 0;

}
</style>
